import React, { Component } from 'react';
import View from '../View';
import './style.css';

class NotFound extends Component {
  render() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <View className='container' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <h1>
          404 <small>Page Not Found :(</small>
          </h1>
        </View>
      </div>
    );
  }
}

export default NotFound;
